import React from 'react';

import { AppBar } from '@material-ui/core';
import InsightsTopNavigation from '../../dashboard/insightsPage/InsightsTopNavigation';

import { makeStyles } from '@material-ui/core/styles';
import { Configuration } from '../../../configs/Configuration';

const useStyles = makeStyles({
  root: {
    backgroundColor: configColors => `rgb(${configColors['--color_54']})`,
    display : 'flex',
    flexDirection : 'row',
    zIndex : 1000
  },
  colorPrimary: {
    color: configColors => `rgba(${configColors['--color_56']}, 0.87)`
  }
});

export default function SecondaryNavbar(){
    const configColors = Configuration.getColors().colors;
    const classes = useStyles(configColors);
    return(
        <AppBar position="static" classes={{root: classes.root, colorPrimary: classes.colorPrimary}}>
            <InsightsTopNavigation />
        </AppBar>
    )
}
